import React from "react";

const WireSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="15" rx="1.5" fill="#E4F4FD" />
      <rect x="0.5" y="0.5" width="23" height="15" rx="1.5" stroke="#15749D" />
      <path
        d="M12.667 7.33324V10.6662H14V7.33324H12.667ZM10 10.6662H11.333V7.33324H10V10.6662ZM15.333 10.6662H15.75C15.888 10.6662 15.9999 10.7783 16 10.9162V11.7502C15.9998 11.8881 15.8879 12.0002 15.75 12.0002H8.25C8.11206 12.0002 8.00021 11.8881 8 11.7502V10.9162C8.00015 10.7783 8.11202 10.6662 8.25 10.6662H8.66699V7.33324H8.25C8.11195 7.33324 8.00003 7.22128 8 7.08324V6.15453C8 6.05983 8.05398 5.97324 8.13867 5.93089L11.8887 4.05589C11.9589 4.02092 12.0411 4.02092 12.1113 4.05589L15.8613 5.93089C15.946 5.97324 16 6.05983 16 6.15453V7.08324C16 7.22128 15.8881 7.33324 15.75 7.33324H15.333V10.6662Z"
        fill="#15749D"
      />
    </svg>
  );
};

export default WireSmallIcon;
